import React from "react";

import AuthUserContext from "./context";
import { withFirebase } from "../Firebase";

const withAuthentication = (Component) => {
    class WithAuthentication extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                authUser: null,
                loaded: false,
            };
        }

        componentDidMount() {
            this.listener = this.props.firebase.auth.onAuthStateChanged((authUser) => {
                if (authUser) {
                    this.props.firebase.user(authUser.uid).on("value", (user) => {
                        user.val()
                            ? this.setState({
                                authUser: { ...authUser, ...user.val() },
                                loaded: true,
                            })
                            : setTimeout(() => {
                                this.setState({ authUser: null, loaded: true });
                            }, 750);

                        //  user?.val()?.defaultLang != undefined && this.props.i18n.changeLanguage(user?.val()?.defaultLang);
                    });
                } else {
                    this.setState({ authUser: null, loaded: true });
                }
            });
        }

        componentWillUnmount() {
            this.listener();
        }

        render() {
            if (!this.state.loaded) {
                return (
                    <div className="loadingBody">
                        {/*} <Grid container justify="center" alignItems="center" style={{ height: "70vh" }}>
            <CircularProgress size={80} color="primary" />
        </Grid>*/}
                        <div className="loadingText" style={{ textAlign: "center" }}>
                            Reanibex Training
                        </div>
                    </div>
                );
            } else {
                //console.log("usuario", this.state.authUser);
                return (
                    <AuthUserContext.Provider value={this.state.authUser}>
                        <Component {...this.props} />
                    </AuthUserContext.Provider>
                );
            }
        }
    }

    return /*compose(withFirebase, withTranslation)*/ withFirebase(WithAuthentication);
};

export default withAuthentication;
